function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.72,
    y: 116.52,
    width: 293.61,
    height: 202.06,
    rx: 16.13,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.44,424.56l-34.1-14.87-.11-.05-.44-.2s-.13-5.86-.38-12.93v-.17c-.18-5.58-.44-11.87-.75-16.58,0-.19,0-.38-.05-.58-.08-1.15-.16-2.19-.26-3.09l-.12-1.21c-.38-3.34-1-8.7-1.84-14.54-.05-.35-.11-.69-.17-1-1.1-7.38-2.6-15.4-4.56-21.11a.61.61,0,0,0,0-.13,28.51,28.51,0,0,0-1.21-3.07c-.08-.21-.19-.4-.28-.6l-2.65-.58c-.89-.2-2-.43-3.15-.67h-.09c-4.41-.95-10.25-2.13-13.66-2.61l-.24,0c-.42-.06-.8-.1-1.13-.13l-.23,0v0c0-.09-.14-.43-.33-.91,0,0,0,0,0,0-.71-1.75-2.58-5.43-6.17-6.9l0,0a8.54,8.54,0,0,0-3.84-.62.08.08,0,0,0-.06,0h0s-.07,0-.1,0l-1.18.09-2.34.18c-4.21.33-7.4.54-8.93.64h0l-.51,0-.36,0H233a2.86,2.86,0,0,0-.41.16c-1.11.55-4.1,2.75-5.48,10.69-.09.48-.13.78-.13.78l-1.06.29L222,335.84h0l-25.25,7s-1.55,6-3.8,14.91l-.06.25-4.22,16.72-.3,1.24c-5.07,20.11-10.8,43.17-12.21,50a2.18,2.18,0,0,0,.84,2.21c3.3,2.45,14.59,9.32,40.21,12.18,0,0-1.07,8.17-.59,8.58h63.63l-.83-10.15h0l-.42-2.74v0l-.5-3.22-.78-5-.68-4.35.43.08.37.06,36.37,7.87Zm-90.31-11.29a46,46,0,0,1-3.4,7.73h0c-.76,1.43-1.33,2.43-1.33,2.43l-28-7.49-.13,0,12.64-39h0l.06-.13,20.18,36.44h0S232.13,413.25,232.13,413.27Z",
    style: {
      fill: "#407BFF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-4",
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.43,98s-48.7-50.32-125.8-47.91S142.79,101.19,88.41,139.34,19.44,236.75,51.09,283s82,26.79,146.07,56.81,76.25,47.08,147.71,39.78,125.8-82,117.68-161.51S411.43,98,411.43,98Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.43,98s-48.7-50.32-125.8-47.91S142.79,101.19,88.41,139.34,19.44,236.75,51.09,283s82,26.79,146.07,56.81,76.25,47.08,147.71,39.78,125.8-82,117.68-161.51S411.43,98,411.43,98Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dashboard--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.72,
    y: 116.52,
    width: 293.61,
    height: 202.06,
    rx: 16.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.45,116.52V318.58h-14.6a16.13,16.13,0,0,1-16.13-16.13V132.65a16.13,16.13,0,0,1,16.13-16.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.45,116.52V318.58h-14.6a16.13,16.13,0,0,1-16.13-16.13V132.65a16.13,16.13,0,0,1,16.13-16.13Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.72,
    y: 116.52,
    width: 293.61,
    height: 202.06,
    rx: 16.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.49,
    y1: 243.58,
    x2: 222.49,
    y2: 242.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.21,
    y1: 243.58,
    x2: 321.21,
    y2: 242.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 243.58,
    x2: 227.35,
    y2: 207.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 239.08,
    x2: 229.82,
    y2: 239.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 234.57,
    x2: 229.82,
    y2: 234.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 230.06,
    x2: 229.82,
    y2: 230.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 225.55,
    x2: 229.82,
    y2: 225.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 221.05,
    x2: 229.82,
    y2: 221.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 216.54,
    x2: 229.82,
    y2: 216.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 212.04,
    x2: 229.82,
    y2: 212.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.35,
    y1: 207.53,
    x2: 229.82,
    y2: 207.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.56,
    y: 216.54,
    width: 5.47,
    height: 27.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.49,
    y: 236.82,
    width: 5.47,
    height: 6.76,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.42,
    y: 235.47,
    width: 5.47,
    height: 8.11,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.34,
    y: 221.05,
    width: 5.47,
    height: 22.54,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.27,
    y: 230.06,
    width: 5.47,
    height: 13.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.19,
    y: 232.32,
    width: 5.47,
    height: 11.26,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.11,
    y: 234.57,
    width: 5.47,
    height: 9.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.04,
    y: 212.04,
    width: 5.47,
    height: 31.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.97,
    y: 239.08,
    width: 5.47,
    height: 4.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.89,
    y: 230.06,
    width: 5.47,
    height: 13.52,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.82,
    y: 221.17,
    width: 5.47,
    height: 22.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.74,
    y: 225.55,
    width: 5.47,
    height: 18.03,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.67,
    y: 234.57,
    width: 5.47,
    height: 9.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.49,
    y1: 243.58,
    x2: 321.21,
    y2: 243.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.92,135h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.21h0a1.22,1.22,0,0,1-1.21-1.21h0A1.21,1.21,0,0,1,214.92,135Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.47,
    y1: 187.17,
    x2: 300.42,
    y2: 187.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.47,
    y1: 187.17,
    x2: 170.47,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.31,
    y1: 187.17,
    x2: 177.31,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.14,
    y1: 187.17,
    x2: 184.14,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.98,
    y1: 187.17,
    x2: 190.98,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.82,
    y1: 187.17,
    x2: 197.82,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.66,
    y1: 187.17,
    x2: 204.66,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.5,
    y1: 187.17,
    x2: 211.5,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.34,
    y1: 187.17,
    x2: 218.34,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.18,
    y1: 187.17,
    x2: 225.18,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.02,
    y1: 187.17,
    x2: 232.02,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.86,
    y1: 187.17,
    x2: 238.86,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.7,
    y1: 187.17,
    x2: 245.7,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.54,
    y1: 187.17,
    x2: 252.54,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.38,
    y1: 187.17,
    x2: 259.38,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.22,
    y1: 187.17,
    x2: 266.22,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.06,
    y1: 187.17,
    x2: 273.06,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.9,
    y1: 187.17,
    x2: 279.9,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.74,
    y1: 187.17,
    x2: 286.74,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.58,
    y1: 187.17,
    x2: 293.58,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.42,
    y1: 187.17,
    x2: 300.42,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.47,
    y1: 187.17,
    x2: 170.47,
    y2: 136.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.47,
    y1: 176.98,
    x2: 173.72,
    y2: 176.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.47,
    y1: 166.78,
    x2: 173.72,
    y2: 166.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.47,
    y1: 156.59,
    x2: 173.72,
    y2: 156.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.47,
    y1: 146.39,
    x2: 173.72,
    y2: 146.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.47,
    y1: 136.2,
    x2: 173.72,
    y2: 136.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.73,
    y1: 146.39,
    x2: 173.89,
    y2: 176.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.57,
    y1: 163.72,
    x2: 180.73,
    y2: 146.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.41,
    y1: 156.59,
    x2: 187.57,
    y2: 163.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.25,
    y1: 174.94,
    x2: 194.41,
    y2: 156.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.08,
    y1: 146.39,
    x2: 201.25,
    y2: 174.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.92,
    y1: 136.2,
    x2: 208.08,
    y2: 146.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.76,
    y1: 182.07,
    x2: 214.92,
    y2: 136.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.6,
    y1: 179.01,
    x2: 221.76,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.44,
    y1: 177.99,
    x2: 228.6,
    y2: 179.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.28,
    y1: 174.94,
    x2: 235.44,
    y2: 177.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.12,
    y1: 170.86,
    x2: 242.28,
    y2: 174.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.96,
    y1: 172.9,
    x2: 249.12,
    y2: 170.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.8,
    y1: 176.98,
    x2: 255.96,
    y2: 172.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.64,
    y1: 155.57,
    x2: 262.8,
    y2: 176.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.48,
    y1: 152.51,
    x2: 269.64,
    y2: 155.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.32,
    y1: 148.43,
    x2: 276.48,
    y2: 152.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.16,
    y1: 152.51,
    x2: 283.32,
    y2: 148.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.99,
    y1: 156.59,
    x2: 290.16,
    y2: 152.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.89,175.77h0A1.21,1.21,0,0,1,175.1,177h0a1.21,1.21,0,0,1-1.21,1.2h0a1.21,1.21,0,0,1-1.21-1.2h0A1.21,1.21,0,0,1,173.89,175.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.73,145.18h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0A1.21,1.21,0,0,1,180.73,145.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.57,162.51h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0A1.21,1.21,0,0,1,187.57,162.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.41,155.38h0a1.21,1.21,0,0,1,1.21,1.2h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0A1.2,1.2,0,0,1,194.41,155.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,173.73h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.2h0a1.21,1.21,0,0,1-1.21-1.2h0A1.21,1.21,0,0,1,201.25,173.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1,145.18h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0A1.21,1.21,0,0,1,208.1,145.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.76,180.86h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,177.81h0a1.2,1.2,0,0,1,1.21,1.2h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0A1.21,1.21,0,0,1,228.6,177.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,176.79h0a1.2,1.2,0,0,1,1.21,1.2h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0A1.21,1.21,0,0,1,235.44,176.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.28,173.73h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.2h0a1.21,1.21,0,0,1-1.21-1.2h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.12,169.65h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.2h0a1.21,1.21,0,0,1-1.21-1.2h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,171.69h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.2h0a1.21,1.21,0,0,1-1.21-1.2h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,175.77h0A1.21,1.21,0,0,1,264,177h0a1.21,1.21,0,0,1-1.21,1.2h0a1.21,1.21,0,0,1-1.21-1.2h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.64,154.35h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,151.3h0a1.21,1.21,0,0,1,1.21,1.21h0a1.21,1.21,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.32,147.22h0a1.21,1.21,0,0,1,1.21,1.21h0a1.22,1.22,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.16,151.3h0a1.21,1.21,0,0,1,1.21,1.21h0a1.22,1.22,0,0,1-1.21,1.21h0a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,155.38h0a1.21,1.21,0,0,1,1.21,1.21h0A1.21,1.21,0,0,1,297,157.8h0a1.22,1.22,0,0,1-1.2-1.21h0a1.21,1.21,0,0,1,1.2-1.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.43,
    y: 272.83,
    width: 159.8,
    height: 33.87,
    rx: 6.95,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 133.89,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 141.21,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 148.53,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 155.84,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 163.16,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 206.1,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 213.42,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 220.74,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 228.06,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 235.38,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 276.45,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 283.77,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 291.09,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 298.41,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 305.73,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 133.89,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 141.21,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 148.53,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 155.84,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 163.16,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 206.1,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 213.42,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 220.74,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 228.06,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 235.38,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 276.45,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 283.77,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 291.09,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 298.41,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.63,
    y: 305.73,
    width: 50.49,
    height: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.75,
    y: 281.23,
    width: 151.73,
    height: 2.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.75,
    y: 288.82,
    width: 151.73,
    height: 2.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.75,
    y: 296.42,
    width: 151.73,
    height: 2.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,227.1,174,238.2a16.27,16.27,0,0,1,.8-23h0a15.7,15.7,0,0,1,11.1-4.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,227.1,200.52,220A16.28,16.28,0,0,1,174,238.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,227.1V210.82A15.76,15.76,0,0,1,200.52,220Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,227.1,174,238.2a16.27,16.27,0,0,1,.8-23h0a15.7,15.7,0,0,1,11.1-4.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.13,436.85s2,5.63.9,5a6.76,6.76,0,0,1-2.76-3.33,7.32,7.32,0,0,0-2.51-3.13l-2.58-2s2.41-1,3.9-.29S337.13,436.85,337.13,436.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.44,434.59s3.46,6.71,2.84,7.25-1,.48-2.3-.73-2.88-5-2.88-5l-2.83-3S337.36,431.73,338.44,434.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.72,425.82s7.22,1.22,8.88,1.46,3.77,2.27,5.45,3.55,7,5.53,6.47,6.76-2.53.11-4.34-1.27-3.16-2.81-5.75-2.34a15.82,15.82,0,0,0-4.95,1.94,32,32,0,0,0,3.74,3.66c1.67,1.28,3.76,3.89,2.91,4.46s-2.08.86-3.95-1-8.06-4.2-9.74-6.39c-3.89-5.09-8.64-5.28-8.64-5.28l8.28-6.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,424.56l-34.1-14.87-.11-.05-.44-.2s-.13-5.86-.38-12.93v-.17c-.18-5.58-.44-11.87-.75-16.58,0-.19,0-.38-.05-.58-.08-1.15-.16-2.19-.26-3.09l-.12-1.21c-.38-3.34-1-8.7-1.84-14.54-.05-.35-.11-.69-.17-1-1.1-7.38-2.6-15.4-4.56-21.11a.61.61,0,0,0,0-.13,28.51,28.51,0,0,0-1.21-3.07c-.08-.21-.19-.4-.28-.6l-2.65-.58c-.89-.2-2-.43-3.15-.67h-.09c-4.41-.95-10.25-2.13-13.66-2.61l-.24,0c-.42-.06-.8-.1-1.13-.13l-.23,0v0c0-.09-.14-.43-.33-.91,0,0,0,0,0,0-.71-1.75-2.58-5.43-6.17-6.9l0,0a8.54,8.54,0,0,0-3.84-.62.08.08,0,0,0-.06,0h0s-.07,0-.1,0l-1.18.09-2.34.18c-4.21.33-7.4.54-8.93.64h0l-.51,0-.36,0H233a2.86,2.86,0,0,0-.41.16c-1.11.55-4.1,2.75-5.48,10.69-.09.48-.13.78-.13.78l-1.06.29L222,335.84h0l-25.25,7s-1.55,6-3.8,14.91l-.06.25-4.22,16.72-.3,1.24c-5.07,20.11-10.8,43.17-12.21,50a2.18,2.18,0,0,0,.84,2.21c3.3,2.45,14.59,9.32,40.21,12.18,0,0-1.07,8.17-.59,8.58h63.63l-.83-10.15h0l-.42-2.74v0l-.5-3.22-.78-5-.68-4.35.43.08.37.06,36.37,7.87Zm-90.31-11.29a46,46,0,0,1-3.4,7.73h0c-.76,1.43-1.33,2.43-1.33,2.43l-28-7.49-.13,0,12.64-39h0l.06-.13,20.18,36.44h0S232.13,413.25,232.13,413.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.04 388.03 281.04 414.72 317.81 429.45 314.12 431.44 276.95 423.44 275.88 412.44 276.92 394.66 281.04 388.03",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.51,353.56l.17,13.32s2.76,10.69,2.22,14.39-4,11.17-6,13.39l-1,17.78,1.56,16.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43,264.2a15.63,15.63,0,0,1,6,7,28.81,28.81,0,0,1,1.7,8.8,103.61,103.61,0,0,1,.38,13.06c-.36,8-2.14,16.13-.4,24,1.15,5.2,4.6,8.43,4.6,14.58L257,330.32s-3.31-7-10.57-8.47l-.49-1.25s5.67.46,10-10.27,3.16-22.64,3.16-22.64l0-12.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.06,315.39l.73,14.93s12.23,21.45,16.32,22.07,0-22-1.71-25.14-3-10.62-3-10.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.52,268.53c-1.06-.65-10.81-1.08-12.15,2.33-1.94,5,1.23,19,.74,18.94-2.33-.07-6-.92-5.47,3.24s3.71,8.17,6,8.52l2.27.35a22.69,22.69,0,0,0,10.44,13.88c9,5.78,15.66,6.51,18.78,1.43a40.43,40.43,0,0,0,6.64-16.52c3-29.35-4.51-35.93-4.51-35.93S232.57,269.18,231.52,268.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.12,266.57s-4.75,20.2-19.71,24.68c0,0,.18,23.11,17.27,28.18,0,0,2.34,16-7.61,13.09l-2-4.11v-13s-8.95-6.78-9.37-13.61c0,0-4.61,0-6.5-3s-3.11-6.89-2.15-9.05,7.46-2.16,7.46-2.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.12,266.57s-4.75,20.2-19.71,24.68c0,0,.18,23.11,17.27,28.18,0,0,2.34,16-7.61,13.09l-2-4.11v-13s-8.95-6.78-9.37-13.61c0,0-4.61,0-6.5-3s-3.11-6.89-2.15-9.05,7.46-2.16,7.46-2.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.24,290.43s22.5-10.63,23.88-23.86c0,0,6.33,14.08,16.3,19.43,0,0,7.42-24.83-15.53-23.38,0,0-16.58-9.68-27.47.11s-8.14,36.67-16.12,52.41-35.5,26.72-12.07,52.64l6.37-24.18,30.34-9.13s1.11-8.41,7.07-10.5l-.29-7.9s-8.06-5.3-10.82-14.16c0,0-4.92-.14-7.59-6.27S217,287.88,221.24,290.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.71,264.1a50.24,50.24,0,0,1-20.56,23.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,261.46a167.37,167.37,0,0,1-15.18,25.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.28,299.62c-.54,6.66-3.71,12.82-7.31,18.45s-7.71,11-10.48,17.06-4.11,13.17-1.86,19.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.44,301.49a92.72,92.72,0,0,1-4.17,36.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,343.6l.37-.11-.36.13-5.88,25.52L185,392.07,191,367.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,343.6l.37-.11-.36.13-5.88,25.52L185,392.07,191,367.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.2,351.74v0a1.07,1.07,0,0,1-.88.37l-.06,0c-2.81-.14-10.89-11.25-11.81-12.52-4.84-6.65-5-7.28-5.5-12.31l-.09-1c-.31-2.95-.48-5.83-.57-7.95,0-.65,0-1.21-.05-1.69.47.24,1,.45,1.41.66,0,.33,0,.69,0,1.08,0,.18,0,.38,0,.59.09,2,.25,4.59.52,7.21l.1,1c.47,4.84.51,5,5.25,11.64,5.38,7.47,9.56,11.67,10.71,11.92a.66.66,0,0,1,.83,0A.68.68,0,0,1,251.2,351.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.63,349.33a.68.68,0,0,1-.67.62.7.7,0,0,1-.62-.77c0-.09,1-10-.67-16.56a30,30,0,0,0-3.36-8.07,5.58,5.58,0,0,1-1.09-2.73c0-.16,0-.33,0-.49s0-.2,0-.3c0-.4,0-.78-.06-1.16a9,9,0,0,0,1.37,0c0,.26,0,.53.06.79s0,.46,0,.69,0,.39,0,.59a5.86,5.86,0,0,0,.83,1.92,30.22,30.22,0,0,1,3.51,8.42C252.66,339.05,251.68,348.92,251.63,349.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,346.37a.7.7,0,0,0-1-.24,14.88,14.88,0,0,0-3.26,3.81,32.35,32.35,0,0,0-3.4,7.27l-7.29-16.4c.15-1.07,1.21-5.78,2.15-9.79a14.47,14.47,0,0,1,4.72-7.21h0a.69.69,0,0,0,0-1,.71.71,0,0,0-1-.12,15.7,15.7,0,0,0-5.19,8c-1.07,4.54-2.19,10.05-2.19,10.05V341l8.82,19.8h.29l.39-1.42a37.77,37.77,0,0,1,3.78-8.58,15.58,15.58,0,0,1,2.84-3.43A.69.69,0,0,0,241,346.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.43,355.2l.22-.08-.41-2.5c-.1-.62-2.43-15.15-7.73-23.46s-9.39-8-9.57-8a.71.71,0,0,0,.15,1.39s3.49-.14,8.26,7.32c3.62,5.68,5.94,15,6.94,19.92a23.68,23.68,0,0,0-5-5.24,5.47,5.47,0,0,0-4.29-.79h0a.69.69,0,0,0,.45,1.3,4.36,4.36,0,0,1,3.19.7c1.72,1,5.17,5.66,6.35,7.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.43,400.9a.32.32,0,0,1-.3-.19.34.34,0,0,1,.13-.46h0l21.25-11.76a.36.36,0,0,1,.46.2.34.34,0,0,1-.12.41l-21.24,11.75A.41.41,0,0,1,245.43,400.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.48,397.37a.37.37,0,0,1-.29-.19.32.32,0,0,1,.14-.45h0l11.53-6a.33.33,0,0,1,.47.13.35.35,0,0,1-.15.48l-11.52,6A.37.37,0,0,1,256.48,397.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,362.11a.35.35,0,0,1-.31-.22,145.35,145.35,0,0,0-9-16.35.34.34,0,0,1,.1-.47h0a.34.34,0,0,1,.47.12,147.5,147.5,0,0,1,9.09,16.48.36.36,0,0,1-.18.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.35,371.25A.32.32,0,0,1,256,371a103.31,103.31,0,0,0-6.09-18.13.34.34,0,0,1,.62-.28,102,102,0,0,1,6.15,18.32.34.34,0,0,1-.28.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,333.81q.06.85.15,2.07c-.2-.24-.34-.42-.44-.55-1.53-2.05-12.71-3.25-20.3-3.58-.53,0-1.06-.05-1.54-.05,0,0-.05,0-.06,0a.67.67,0,0,1-.6-.7,1,1,0,0,1,.06-.26h0a.68.68,0,0,1,.65-.39l1.23.05c3.82.18,14.43.77,19.39,2.72A7.64,7.64,0,0,1,279.07,333.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,376.69c.09.49.15,1,.23,1.45l-.35-.21a.69.69,0,0,1-.21-1s.05-.08.08-.09A.4.4,0,0,1,283,376.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,285.66c0-.18,0-.34,0-.52,0-1.3-.1-2.62-.17-3.92l0-.25-.54,1h0l-.13.23-.49.88c0,.39,0,.79,0,1.18,0,.22,0,.43,0,.64.08,3.84-.12,7.87-.43,11.75-.12,1.6-.28,3.16-.43,4.67a36.19,36.19,0,0,1-6.2,15.53s0,0,0,.06a4.9,4.9,0,0,1-.89,1.15,5.91,5.91,0,0,1-1.95,1.34l-.44.17a3.92,3.92,0,0,1-.56.16,7,7,0,0,1-.82.13,3,3,0,0,1-.43,0l-.45,0c-.3,0-.61,0-.92,0a14.6,14.6,0,0,1-2.45-.44h0a28.76,28.76,0,0,1-6.82-3h0l0,0h0s0,0,0,0h0c-.43-.26-.88-.52-1.33-.81a.28.28,0,0,1-.09-.06h0l-.52-.33a22.29,22.29,0,0,1-10.13-13.41l-.09-.5-2.78-.43c-2-.31-4.92-4.08-5.4-7.92a2.45,2.45,0,0,1,.31-2c.57-.69,2.05-.6,3.33-.52a8.12,8.12,0,0,0,1,.07,9.29,9.29,0,0,0,1.18,0l-.82-1.23h-.32l-.91-.14c-1.45-.09-3.07-.19-4.15.62a.69.69,0,0,0-.22.2.37.37,0,0,0-.15.11,3.74,3.74,0,0,0-.82,2.27v.13a.07.07,0,0,0,0,.05,3.57,3.57,0,0,0,.12.69,13.54,13.54,0,0,0,3,6.7,6.4,6.4,0,0,0,3.56,2.43l1.83.28A23.79,23.79,0,0,0,233,316.4l.09.06.05,0c.22.14.42.29.64.42l.56.35.44.27a6.72,6.72,0,0,0,.7.4v0l.21.1.42.22h0a30.08,30.08,0,0,0,6.77,2.63c.38.1.76.19,1.16.27a9.37,9.37,0,0,0,1.2.15l.36,0c.22,0,.45,0,.67,0h.63l.3,0a4.1,4.1,0,0,0,.49-.06h0l.28,0a1.25,1.25,0,0,0,.27-.1h0a1.43,1.43,0,0,0,.28-.07,7.4,7.4,0,0,0,4.16-3.34c3.24-5.32,5.63-9.61,6.74-16.83.17-1.71.3-3.41.4-5.12C260,292.39,260.08,289,260,285.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,289.21c0,1.12-.43,2-1,2s-1-.91-1-2,.44-2,1-2S244,288.1,244,289.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.66,289.93c0,1.12-.44,2-1,2s-1-.91-1-2,.42-2,1-2S255.65,288.84,255.66,289.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,283.25a.74.74,0,0,1-.34-.15.71.71,0,0,1-.09-1,8.47,8.47,0,0,1,7.79-2.62.69.69,0,0,1,.58.79.7.7,0,0,1-.79.58,7,7,0,0,0-6.44,2.17A.75.75,0,0,1,236,283.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.84,285.78a.73.73,0,0,1-.48-.3,5.07,5.07,0,0,0-5.26-2.43.71.71,0,0,1-.84-.52.66.66,0,0,1,.48-.82h0a6.43,6.43,0,0,1,6.76,3,.7.7,0,0,1-.15,1h0A.71.71,0,0,1,257.84,285.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,301.05a.7.7,0,0,1,.17-1.38s1.82.22,2.37-1c.28-.58.11-1-.24-1.65a6.23,6.23,0,0,1-.71-2.74,31.86,31.86,0,0,1,.68-5.59.69.69,0,0,1,.82-.53h0a.69.69,0,0,1,.53.82h0a30.35,30.35,0,0,0-.65,5.29,4.77,4.77,0,0,0,.58,2.16,3.1,3.1,0,0,1,.22,2.91C250.43,301.37,247.75,301.07,247.62,301.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,305.59a6.77,6.77,0,0,1-4.18-2.17.7.7,0,0,1,.09-1,.68.68,0,0,1,1,.08h0a6.42,6.42,0,0,0,4.95,1.77.7.7,0,0,1,.74.64.69.69,0,0,1-.62.75A9.11,9.11,0,0,1,241,305.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.55,334.46s10.28,29.93,8.73,74.78l35.16,15.32-8.32,6.89-37.17-8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,350l-.61,9.48L252,364l3.63-.65,1.13-6.38-5.35-8.49S253.32,352.59,247,350Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.95 364.01 254.96 413.83 263.08 421.05 267.25 409.91 254.95 360.25 251.95 364.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.31,347.79l10.09,5.77v-3.09l-6.17-5.92A9.18,9.18,0,0,0,238.31,347.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91,352.34l1.13-8s4.26-1.39,5.67.66l-5.15,9.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.35,283a6.22,6.22,0,1,1-6.85,5.51A6.21,6.21,0,0,1,243.35,283Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.33,284.55c3.06.32,5.25,3.36,4.88,6.77s-3.15,5.92-6.21,5.59-5.25-3.37-4.88-6.78S254.27,284.22,257.33,284.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.12,
    y1: 288.53,
    x2: 220.61,
    y2: 287.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.05,
    y1: 288,
    x2: 251.61,
    y2: 288.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.89,416.13c-7.12-.73-13.86,7.64-13.86,7.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.35,417.87s9.58-5.35,17.77-1.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.28,409.24s-5.94,2.64-7.29,8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.38,257.33c4-3.21,17.42-3.09,21.39,6.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.93,425.12l1.38-7.26,11.6-4.63H239.76L250.37,407l-11.24,2.24s-21.83-35.12-31.51-49.71v0c-1.3-1.95-2.37-3.53-3.15-4.61l2.84,10.89.41,1.57.67,2.57,1.4,5.36-6.87-8.14,2.63,9.55-13.31,37.6-5.3,2.05-.09,0-1.81.7,7.19.66L187,421.67l0,0,10-1.77,67.57,15.69.69-2.49Zm-8.2-4.11c-.76,1.43-1.33,2.43-1.33,2.43l-28-7.49-.13,0,13.07-38.79c.31.61,18.61,33.93,19.81,36.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.88,
    y1: 410.34,
    x2: 195.51,
    y2: 348.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.24,440.1l-.44-.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.6,431.72c-3.54-2.47-7.51-2.28-10.88-2.16-2.42.08-8.08,2.33-13.73,3.74a3.63,3.63,0,0,1-1.08.05c0,.55-1,4.92-1.43,7.24a7.34,7.34,0,0,0,1.76-.21,2.9,2.9,0,0,1,1.46.09,21.57,21.57,0,0,0,3.91.84c2.23.32,6.46-.14,8,1.74a23.49,23.49,0,0,0,4.46,3.92c1.32,1,2.88,2.08,4.6,1.86,1.42-.18-.37-1.33-.78-1.71a30,30,0,0,1-3.29-4.17c-.34-.45-1.47-2.3-2.05-2.41a15.73,15.73,0,0,0,1.72.24c.78.06,1.57.76,2.59,1.56a25.74,25.74,0,0,0,2.73,2c.42.31,5.42,3.14,5.15,1-.09-.66-1.22-1.47-1.65-1.91a40.05,40.05,0,0,0-7.25-5.85l4.08,1.1a19.76,19.76,0,0,1,2.07,1.41c.37.31.79.65,1.24,1,.75.58,2.81,1.76,3.76,1.3,1.53-.73-3.17-5.24-3.91-5.82s-4.92-3.06-5.12-3.22l-.87-.44-.14-.11a37,37,0,0,1,5.9,2.94c1.53,1.19,3.18,3.29,4.88,2.15S294.14,434.19,290.6,431.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.32,377.12l-13.43,39,66.35,17L263,441.09a248.1,248.1,0,0,1-45-.9l-.68-.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "206.8 366.77 232.13 413.26 228.97 420.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 424.77,
    y1: 448.95,
    x2: 75.23,
    y2: 448.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Computer--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.66,
    y: 446.82,
    width: 45.96,
    height: 2.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 370.92,
    width: 99.08,
    height: 63.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.3,
    y: 370.92,
    width: 93.67,
    height: 63.9,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.01 400.61 367.69 400.61 368.48 449.15 346.8 449.15 346.01 400.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.01,
    y: 399.73,
    width: 21.68,
    height: 49.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "370.2 434.97 370.2 401.19 346.57 401.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.84,
    y: 445.68,
    width: 66.37,
    height: 3.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 445.68,
    width: 83.05,
    height: 3.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.32,401.73a17.21,17.21,0,0,0,0-13.92c-3.29-7.58-12.69-8-12.69-8s2.78,2.8,2.88,9.37S99.21,401,105.32,401.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66,405.84s-3.45-8.74-10.37-10.62-12.32,3.7-16.61,2.17C73.68,397.39,83.72,411.33,100.66,405.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.84,396.82s2.91-13.21-12.39-15.22c0,0,1.43,1,2.38,5.44S118.24,396.27,126.84,396.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.68,418.36s1.57-12,19.39-10.13c0,0-2.33,1.08-4,5S138.62,421.27,126.68,418.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,391.8s3.78-12.35,17-9.87C151.93,381.93,150.51,395.65,134.92,391.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,401.73a17.21,17.21,0,0,0,0-13.92c-3.29-7.58-12.69-8-12.69-8s2.78,2.8,2.88,9.37S99.21,401,105.32,401.73Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66,405.84s-3.45-8.74-10.37-10.62-12.32,3.7-16.61,2.17C73.68,397.39,83.72,411.33,100.66,405.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.84,396.82s2.91-13.21-12.39-15.22c0,0,1.43,1,2.38,5.44S118.24,396.27,126.84,396.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.68,418.36s1.57-12,19.39-10.13c0,0-2.33,1.08-4,5S138.62,421.27,126.68,418.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,391.8s3.78-12.35,17-9.87C151.93,381.93,150.51,395.65,134.92,391.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.85 428.06 132.38 428.06 128.82 448.36 109.47 448.36 105.85 428.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "120.68 430.47 129.52 400.72 139.38 381.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.07,
    y1: 386.34,
    x2: 134.36,
    y2: 391.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.08,
    y1: 391.11,
    x2: 129.22,
    y2: 401.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.29,
    y1: 415.31,
    x2: 123.64,
    y2: 420.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.99,
    y1: 394.21,
    x2: 120.68,
    y2: 436.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.45,
    y1: 408.79,
    x2: 88.96,
    y2: 400.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBro);
export default __webpack_public_path__ + "static/media/Dashboard-bro.d187d37acb13483ca8c31291a7b3c170.svg";
export { ForwardRef as ReactComponent };